import { html } from "lit";
var icon_hide_default = () => html`
  <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4.53 27.4 27.86 5" />
      <path
        d="M12.22 24.97c1.22.38 2.5.57 3.78.56 5.1.09 10.27-3.5 13.47-7.01.7-.79.7-1.98 0-2.77a25.6 25.6 0 0 0-3.83-3.43" />
      <path
        d="M19 9.08c-.98-.24-1.99-.36-3-.35-5.02-.08-10.2 3.43-13.47 7.02-.7.78-.7 1.98 0 2.77 1 1.08 2.08 2.08 3.24 2.98" />
      <path d="M11.33 17.13A4.67 4.67 0 0 1 16 12.47" />
      <path d="M20.66 17.13h0A4.67 4.67 0 0 1 16 21.8" />
    </g>
  </svg>
`;
export {
  icon_hide_default as default
};
//# sourceMappingURL=icon-hide.js.map
